// material-ui
import { Theme } from '@mui/material/styles';

// ==============================|| OVERRIDES - Slider ||============================== //

export default function Slider(theme: Theme) {
  // return null;
  return {
    MuiSlider: {
      styleOverrides: {
        track: {
          height: '4px'
        },
        thumb: {
          width: 16,
          height: 16
        },
        root: {
          '&.Mui-disabled': {
            '.MuiSlider-rail': {
              opacity: 0.25
            }
          }
        },
        valueLabel: {
          backgroundColor: theme.palette.grey[600],
          color: theme.palette.grey[0]
        }
      }
    }
  };
}
